// Port of Flutter's AutoHorizontalScroll (homeScreenFunctions.dart): a single
// line of device text that scrolls itself end-to-end every 3 s, reversing each
// time, so long device names stay readable inside a small card.

import React, { useEffect, useRef } from 'react';
import { Box, useTheme } from '@mui/material';

export default function AutoHorizontalScroll({ text, fontSize = 14 }) {
  const ref = useRef(null);
  const forwardRef = useRef(true);
  const theme = useTheme();

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const id = setInterval(() => {
      const max = el.scrollWidth - el.clientWidth;
      if (max <= 0) return;
      el.scrollTo({ left: forwardRef.current ? max : 0, behavior: 'smooth' });
      forwardRef.current = !forwardRef.current;
    }, 3000);
    return () => clearInterval(id);
  }, [text]);

  return (
    <Box
      ref={ref}
      // data-hscroll: scrolls horizontally, so tab-swipe ignores gestures that
      // start on it (see useSwipeNav).
      data-hscroll
      sx={{
        width: '100%',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      <Box
        component="span"
        sx={{
          display: 'inline-block',
          whiteSpace: 'nowrap',
          width: '100%',
          textAlign: 'center',
          color: theme.sli.text,
          fontSize,
          fontWeight: 700,
          textShadow: '1px 1px 2px rgba(0,0,0,0.54)',
        }}
      >
        {text}
      </Box>
    </Box>
  );
}
